//      
export function noop()       {}

export function identity   (value   )    {
  return value;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/empty.js